import React from 'react';

import i18n from '../../i18n';

// @mui
import {
    TextField,
} from '@mui/material';

export default class DialogBigTextField extends React.Component {
    render() {
        // field, value, cache, onChange
        let show = this.props.field.show;
        let value = this.props.value?.[show] || this.props.value;
        let translatedName = i18n.t(`columns.${this.props.field.label}`);
        const onlyRead = !!this.props.field.onlyRead;

        return (
            <TextField
                key={this.props.field.id}
                autoFocus
                margin="dense"
                id={this.props.field.id}
                label={translatedName}
                type="text"
                defaultValue={value || ""}
                disabled={onlyRead}
                fullWidth
                multiline
                minRows={3}
                maxRows={10}
                onChange={(event) => this.props.onChange(event.target.id, event.target.value)}
            />
        );
    }
}
